import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

interface Signature {
  Args: {
    label: string;
    value: string;
    inputId: string;
  };
}

export default class LtiCopyUrlField extends Component<Signature> {
  @tracked copied = false;

  copy = async () => {
    try {
      await navigator.clipboard.writeText(this.args.value);
      this.copied = true;
      window.setTimeout(() => {
        this.copied = false;
      }, 2000);
    } catch {
      // Clipboard may be unavailable in some contexts.
    }
  };

  <template>
    <div>
      <label class="form-label mb-0" for={{@inputId}}>{{@label}}</label>
      <div class="input-group input-group-sm">
        <input
          id={{@inputId}}
          type="text"
          class="form-control font-monospace"
          value={{@value}}
          readonly
        />
        <button
          class="btn btn-outline-primary"
          type="button"
          {{on "click" this.copy}}
          title="Copy to clipboard"
        >
          {{#if this.copied}}
            <iconify-icon inline icon="ph:check" />
          {{else}}
            <iconify-icon inline icon="ph:copy" />
          {{/if}}
        </button>
      </div>
    </div>
  </template>
}
